export enum QuickbooksReport {
    NewOrders = 1,
    NewPaymentsForNewOrders = 2,
    UpdatesOnExportedOrders = 3,
}

export const QuickbooksReportDisplayName: Record<QuickbooksReport, string> = {
    [QuickbooksReport.NewOrders]: 'New Orders',
    [QuickbooksReport.NewPaymentsForNewOrders]: 'New Payments for New Orders',
    [QuickbooksReport.UpdatesOnExportedOrders]: 'Updates on Exported Orders',
};
